<template>
  <div>
    <section class="hero has-shadow is-grey-ligth" id="headerClima">
      <div class="hero-head" style="margin-bottom: 20px;">
        <br />
        <div
          class="container is-flex is-justify-between"
          style="align-items: center; margin: 0px 25px 0 13px;"
        >
          <h1
            class="title has-text-weight-bold has-text-dark is-2"
            style="margin-bottom: 0; text-wrap: nowrap;"
          >
            CL7
          </h1>
          <div
            v-if="tokenUser"
            class="text-card"
            v-tooltip.bottom="{
              content: empresa.nombre,
              trigger: isMovil ? 'click' : 'manual',
            }"
          >
            <span class="is-size-6 w-full truncate">{{ empresa.nombre }}</span>
            <p
              v-if="proceso.nombre !== '.....'"
              class="is-size-5 has-text-weight-bold truncate"
            >
              {{ proceso.nombre }}
            </p>
          </div>
        </div>
      </div>
      <div class="hero-foot">
        <!-- Menu -->
        <nav class="tabs is-boxed">
          <div class="container">
            <ul>
              <li
                v-bind:class="{
                  'is-active': activo('yResultado') || activo('yGuide'),
                }"
                @click="
                  selectSection({
                    d: 'yGuide',
                    name: 'Guia',
                  })
                "
              >
                <a href="#">Resultados</a>
              </li>
              <li
                v-bind:class="{ 'is-active': activo('yFiles') }"
                @click="selectSection({ d: 'yFiles', name: 'Anexos' })"
              >
                <a href="#">Anexos</a>
              </li>
            </ul>
          </div>
        </nav>
      </div>
    </section>
    <div v-if="proceso">
      <div class="is-mobileClima">
        <button
          v-if="select === 'yResultado'"
          class="button is-link"
          :class="showMenu ? 'button-Clima-open' : 'button-Clima-closed'"
          :style="isOculto ? 'margin-left: 91.5%;' : 'margin-left: 77.7%;'"
          v-on:click="changeMenu"
        >
          <span class="icon"><i class="material-icons">info_outline</i></span>
        </button>
        <br />
        <transition name="fade">
          <div
            v-if="showMenu"
            class="button is-link"
            v-tooltip.left="'Volver atras'"
            style="top: 80px"
            :class="
              sectInter !== '' ? 'button-Clima-open' : 'button-inter-closed'
            "
            v-on:click="selectVar('')"
          >
            <span class="icon"><i class="material-icons">arrow_back</i></span>
          </div>
        </transition>
      </div>
      <section
        class="is-fullheight is-fullwidth"
        :class="{ colums: !activo('yGuide') }"
        style="transition: all 0.3s ease 0s !important;"
      >
        <div
          :class="{ 'container colum': !activo('yGuide') }"
          style="transition: all 0.3s ease 0s !important;"
        >
          <div
            v-if="Object.keys(proceso).length"
            :class="{
              container: !activo('yGuide'),
              'container-guie': activo('yGuide'),
            }"
          >
            <component
              ref="content"
              :is="select"
              :proceso="proceso"
              :process="proceso"
              :tokenUser="tokenUser"
              @selectSection="selectSection"
            ></component>
          </div>
        </div>
        <div
          :class="
            select === 'yResultado' && showMenu ? 'column is-2' : 'column is-0'
          "
          style="transition: all 0.3s ease 0s !important;"
        >
          <aside
            :class="showMenu ? 'sidebarClima-show' : 'sidebarClima-none'"
            class="is-narrow-mobile is-fullheight section is-hidden-mobile scroll-light"
            style="overflow-y: scroll"
          >
            <p
              class="has-text-centered is-size-4 has-text-weight-bold has-text-dark"
            >
              Interpretaciones
            </p>
            <div v-for="(item, k) in calificaciones" :key="k">
              <transition name="fade">
                <div v-if="sectInter === '' || sectInter === item.title">
                  <br />
                  <div
                    class="tags has-addons"
                    style="cursor: pointer"
                    v-on:click="selectVar(item.title)"
                  >
                    <span
                      class="tag is-medium is-dark is-flex"
                      style="width: 100%; justify-content: space-between"
                    >
                      <span></span>
                      <span>{{ item.title }}</span>
                      <span class="icon"
                        ><i class="material-icons is-size-1"
                          >arrow_drop_down</i
                        ></span
                      >
                    </span>
                  </div>
                  <div class="text-justify is-size-7">{{ item.def }}</div>
                </div>
              </transition>
              <transition name="fade">
                <div v-if="sectInter === item.title">
                  <div v-for="(itVar, kv) in item.dimensiones" :key="kv">
                    <hr />
                    <div class="tags has-addons">
                      <span class="tag is-medium" style="width: 100%">
                        {{ itVar.title }}
                      </span>
                    </div>
                    <div class="text-justify is-size-7">{{ itVar.inter }}</div>
                  </div>
                  <br />
                </div>
              </transition>
            </div>
          </aside>
        </div>
      </section>
    </div>
    <div v-if="!proceso" class="container content-imgNotFound">
      <div>
        <img
          src="@/assets/notFoundData.svg"
          width="450"
          alt="https://storyset.com/data"
        />
        <h2 style="font-weight: bold">
          No se encontró un proceso para mostrar
        </h2>
      </div>
    </div>
  </div>
</template>

<script>
import apiServices from "@/services/yungol-services";
import yResultado from "./Resultadosclima.vue";
import yFiles from "@/components/attached/uploadFilesBoard.vue";
import yGuide from "./GuiaInterpretacion.vue";
import { mapState } from "vuex";
import json from "./interpretaciones.json";
export default {
  data() {
    return {
      select: "yGuide", // yResultado
      title: "Guia", // Resultados
      proceso: {},
      showMenu: false,
      calificaciones: json,
      sectInter: "",
    };
  },
  computed: {
    ...mapState(["idtoken", "isOculto", "tokenUser", "isMovil", "empresa"]),
  },
  methods: {
    async findProcess() {
      let result;
      try {
        result = await apiServices.get("findcohorteclimacliente");
        if (result.data) {
          this.proceso = {
            ...result.data[0],
            processComp: result.data[0].comparison,
          };
          delete this.proceso.comparison;
          this.compo = "yResultado";
        }
      } catch (err) {
        console.log(err);
      }
    },
    selectSection({ d, name }) {
      if (this.proceso.nombre !== ".....") {
        this.select = d;
        this.title = name;
        this.showMenu = false;
      } else {
        this.$store.dispatch("notify", {
          message: `Error al entrar a la pestaña`,
          type: "is-danger",
        });
        this.showMenu = false;
      }
    },
    changeMenu() {
      this.showMenu ? (this.showMenu = false) : (this.showMenu = true);
    },
    selectVar(group) {
      if (this.sectInter === group) {
        this.sectInter = "";
      } else {
        this.sectInter = group;
      }
    },
    activo(a) {
      if (a === this.select) {
        return true;
      } else {
        return false;
      }
    },
  },
  watch: {
    idtoken(nv) {
      if (nv) {
        this.findProcess();
      }
    },
    isOculto(nv) {
      if (!nv) {
        this.showMenu = false;
      }
    },
  },
  created() {
    if (this.idtoken) {
      this.findProcess();
    }
  },
  components: {
    yResultado,
    yGuide,
    yFiles,
  },
};
</script>

<style scoped lang="scss">
.container-guie {
  margin-top: -28px;
}

.sidebarClima-show {
  z-index: 50;
  background: white;
  position: fixed;
  height: 100%;
  width: 256px;
  right: 0;
  top: 0;
  transition: all 0.3s ease 0s;
  box-shadow: 48px -6px 46px 29px black;
}

.sidebarClima-none {
  z-index: 0;
  background: white;
  position: fixed;
  height: 100%;
  width: 256px;
  right: -300px;
  top: 0;
  transition: all 0.3s ease 0s;
  box-shadow: 48px -6px 46px 29px black;
}

.button-inter-closed {
  display: none;
  transition: all 0.3s ease 0s;
  z-index: 61;
}

.button-Clima-closed {
  position: fixed;
  top: 47px;
  padding: 15px;
  margin-left: 91.5%;
  transition: all 0.3s ease 0s;
  z-index: 61;
}

.button-Clima-open {
  position: fixed;
  top: 47px;
  padding: 15px;
  margin-left: 74.5% !important;
  transition: all 0.3s ease 0s;
  z-index: 61;
}

.is-mobileClima {
  @media (max-width: 769px) {
    display: none !important;
  }
}

.content-imgNotFound {
  height: 100vh !important;
  display: flex !important;
  align-items: center !important;
  text-align: center !important;
  justify-content: center;
}

a.dropdown-item.is-active,
button.dropdown-item.is-active {
  background-color: #522687;
  color: #fff;
}

.tabs.is-toggle li.is-active a {
  background-color: #522687;
  border-color: #905fbf;
  color: white;
  z-index: 1;
}

.hero.is-grey-ligth {
  padding-left: 40px;
}

.hero.is-grey-ligth .tabs.is-boxed li.is-active a {
  background-color: white;
  border: solid 0 white;
  color: #522687 !important;
  box-shadow: #00000029 0px 14px 20px;
}

.hero.is-grey-ligth .tabs.is-boxed li:hover a {
  background-color: rgba(191, 191, 191, 0.475);
  border: solid 0 rgba(191, 191, 191, 0.475) !important;
  color: #522687 !important;
}

.hero.is-grey-ligth .tabs.is-boxed a {
  border: 0px solid transparent;
  border-radius: 4px 4px 0 0;
}

.text-card {
  padding: 3px 10px;
  border-radius: 10px;
  background-color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/climan/HomeClima.vue